<router-outlet></router-outlet>

<router-outlet name="aux"></router-outlet>
